import { Button, Flex, Stack, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import style from "./hero.module.css";
import { IconArrowRight } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import InfoSlab from "../../../../molecules/infoSlab/infoSlab";
import { freeTrialWithoutPaymentCardEnabled } from "../../../../App";

const HeroSegment = () => {
    const { t } = useTranslation(["landing-page"]);
    const navigate = useNavigate();

    return (
        <div className={style.wrapper}>
            <div className={style.innerWrapper}>
                <div className={style.leftWrapper}>
                    <h1 className={style.header}>
                        {t("hero.title.check")} <span className={style.blueHeader}>{t("hero.title.real")}</span> {t("hero.title.or")}{" "}
                        <span className={style.blueHeader}>{t("hero.title.ai")}</span>
                    </h1>

                    <p className={style.text}>{t("hero.description")}</p>

                    <Button
                        onClick={() => navigate("/sign-up")}
                        size="md"
                        color="dark"
                        radius={"xl"}
                        variant="filled"
                        mt={"1.5rem"}
                        w={freeTrialWithoutPaymentCardEnabled ? "12rem" : "fit-content"}
                        rightIcon={<IconArrowRight size={"1rem"} />}
                    >
                        {freeTrialWithoutPaymentCardEnabled ? t("hero.cta.try_free") : t("hero.cta.try_free_30_days")}
                    </Button>
                    {freeTrialWithoutPaymentCardEnabled && <Text fz={11} mt={"0.5rem"} w={"12rem"} ta={"center"}>{t("hero.cta.no_payment_card_required")}</Text>}
                </div>

                <div className={style.screenshotWrapper}>
                    <Flex columnGap={"1rem"}>
                        <Stack spacing={"0.5rem"}>
                            <p className={style.screenshotText}>{t("hero.sample.paragraph1")}</p>

                            <p className={style.screenshotText}>{t("hero.sample.paragraph2")}</p>
                        </Stack>

                        <Stack miw={160}>
                            <InfoSlab aiScore={1} displayExplainations={false} scan={{ version: "5.0" }} smallVersion={true} />
                        </Stack>
                    </Flex>
                </div>
            </div>
        </div>
    );
};

export default HeroSegment;
